import { Routes } from '@/globalTypes.ts';
import { MenuItemConfig } from '@/components/Header/types.ts';

// TODO: move Log Out modal state to context and remove onLogout prop
export const useProfileMenuItems = ({
  onLogout,
}: {
  onLogout: () => void;
}): MenuItemConfig[] => {
  return [
    {
      label: 'Change Password',
      pathname: Routes.PasswordChange,
    },
    {
      label: 'Log Out',
      pathname: Routes.LogOut,
      onClick: onLogout,
      mobileStyles: {
        fontWeight: '500 !important',
      },
    },
  ];
};
